'use client';

import CommonLoading from '@/components/layouts/CommonLoading/CommonLoading';
import { useIntersection } from '@/hooks/useIntersection';
import { useRef } from 'react';

export function InfiniteScroll({
  hasMore,
  isLoading,
  onLoadMore,
  loadingComponent,
  rootMargin = '200px',
  sentinelClassName,
}: {
  hasMore: boolean;
  isLoading: boolean;
  onLoadMore: () => void;
  loadingComponent?: React.ReactNode;
  rootMargin?: string;
  sentinelClassName?: string;
}) {
  const sentinelRef = useRef<HTMLDivElement>(null);

  useIntersection(sentinelRef, onLoadMore, {
    enabled: hasMore && !isLoading,
    rootMargin,
  });

  return (
    <div ref={sentinelRef} className={sentinelClassName} style={{ minHeight: 1 }} aria-hidden>
      {isLoading && (loadingComponent ?? <CommonLoading />)}
    </div>
  );
}
